import React from 'react'
import BooksDetail from '../books/BooksDetail'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'

type Props = {}

const AudioBookDetail: React.FC<Props> = (props: Props) => {
    return (
        <BooksDetail
            library_category={ELibraryCategory.AUDIO_BOOK}
            library_head_name='หนังสือเสียง'
            library_head_pathname={routeName.e_library.audio_book}
            library_head_list_path={routeName.e_library.audio_book_list}
        />
    )
}

export default AudioBookDetail